import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import Card from '../components/ui/Card';

export default function TrainingProgram() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('trainingProgram');

  const handleBack = () => {
    // Check if user came from within the app
    const fromPath = location.state?.from;
    if (fromPath) {
      navigate(fromPath);
    } else {
      // Default to home page
      navigate('/');
    }
  };

  return (
    <>
      <Helmet>
        <title>{t('meta.title')}</title>
        <meta name="description" content={t('meta.description')} />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <div className="container-custom py-12">
          {/* Back Button */}
          <button
            onClick={handleBack}
            className="flex items-center gap-2 text-primary hover:text-primary-dark mb-6 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            {t('back')}
          </button>

          {/* Content */}
          <Card padding="lg" className="max-w-4xl mx-auto">
            {/* Logo Section */}
            <div className="flex justify-center mb-8">
              <img src="/logo.svg" alt="YOYO Club" className="h-20" />
            </div>

            <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t('title')}</h1>

            {/* Introduction */}
            <div className="mb-8 text-center">
              <p className="text-gray-700 text-lg leading-relaxed">{t('intro')}</p>
            </div>

            {/* Divider */}
            <div className="my-8" />

            {/* Main Content */}
            <div className="space-y-6">
              {/* Development Notice */}
              <div className="p-6 bg-primary-pale rounded-lg">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{t('notice.title')}</h3>
                <p className="text-gray-700 mb-4 leading-relaxed">{t('notice.description')}</p>
                <a
                  href="mailto:hello@sayyoyo.com"
                  className="text-primary hover:underline font-semibold text-lg inline-flex items-center gap-2"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  hello@sayyoyo.com
                </a>
              </div>
            </div>

            {/* Thank You Message */}
            <div className="mt-8 text-center">
              <p className="text-gray-600 italic">{t('thankYou')}</p>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
